import { useLocalStorage } from '@distribute/frontend/utils';
import { CALL_RECORDING_RIGHT_SIDEBAR_CALENDAR } from '../../../shared/constants';

export const useCalendarSidebar = () => {
  const [isMeetingEventsSidebarOpen, setIsMeetingEventsSidebarOpen] =
    useLocalStorage(CALL_RECORDING_RIGHT_SIDEBAR_CALENDAR, true);

  return { isMeetingEventsSidebarOpen, setIsMeetingEventsSidebarOpen };
};
